import React, { useCallback, useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'

import Section, { SectionBox, SectionOption } from '../../../../components/Section'
import List, { ListSection, ListRow, ListColumn, ListOption } from '../../../../components/List'
import Modal from '../../../../components/Modal'
import { MagicSelectForm } from '../../../../components/Select/MagicSelectForm'
import { CircleSpinner } from 'react-spinners-kit'
import { mdiPlusCircle, mdiMicrosoftExcel, mdiDelete } from '@mdi/js'

import { useAppSelector } from '../../../../store/hooks'
import getClients from '../Cliente/scripts/getClients'
import { ClienteType } from '../Parametro/Types/ClienteType'
import getAnaliseAmostraTerceira, {
  AnaliseAmostraTerceiraItem
} from './scripts/getAnaliseAmostraTerceira'
import addAnaliseAmostraTerceira from './scripts/addAnaliseAmostraTerceira'
import excelProgramacaoSelecaoEnsTerceiros from './scripts/excelProgramacaoSelecaoEnsTerceiros'
import deleteAnaliseAmostraTerceira from './scripts/deleteAnaliseAmostraTerceira'
import TextField from '@material-ui/core/TextField'

type MagicOption = {
  value: string
  label: string
}

const ProgramacaoSelecaoEnsTerceiros: React.FC = () => {
  const dispatch = useDispatch()
  const { clients, requestGet } = useAppSelector(state => state.ClientsReducer)

  const [selectedPessoas, setSelectedPessoas] = useState<MagicOption[]>([])
  const [listaAnalise, setListaAnalise] = useState<AnaliseAmostraTerceiraItem[]>([])
  const [loadingAnalise, setLoadingAnalise] = useState<boolean>(false)
  const [openModal, setOpenModal] = useState<boolean>(false)
  const [openConfirmModal, setOpenConfirmModal] = useState<boolean>(false)
  const [itemSelecionado, setItemSelecionado] = useState<AnaliseAmostraTerceiraItem | null>(null)
    const [titulo, setTitulo] = useState<string>('')
  useEffect(() => {
    ;(async () => {
      await getClients('ProgramacaoSelecaoEnsTerceiros', dispatch)
    })()
  }, [dispatch])

  const reloadAnalise = useCallback(async () => {
    try {
      setLoadingAnalise(true)
      const resultados = await getAnaliseAmostraTerceira()
      setListaAnalise(resultados ?? [])
    } finally {
      setLoadingAnalise(false)
    }
  }, [])

  useEffect(() => {
    ;(async () => {
      await reloadAnalise()
    })()
  }, [reloadAnalise])

  const optionsPessoas: MagicOption[] =
    clients?.map((pessoa: ClienteType) => ({
      value: String(pessoa.id),
      label: pessoa.nome
    })) ?? []

  const handleAddSelecionados = useCallback(async () => {
    const ids = selectedPessoas
      .map(item => Number(item.value))
      .filter(id => !Number.isNaN(id))

    if (ids.length === 0) return

    try {

      console.log(ids, titulo)
      await addAnaliseAmostraTerceira(ids, titulo)
      setSelectedPessoas([])
      setTitulo('')
      setOpenModal(false)
      await reloadAnalise()
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Erro ao adicionar análise de amostra terceira:', error)
    }
  }, [selectedPessoas, reloadAnalise, titulo])

  const handleOpenConfirmExcluir = useCallback((item: AnaliseAmostraTerceiraItem) => {
    setItemSelecionado(item)
    setOpenConfirmModal(true)
  }, [])

  const handleCancelExcluir = useCallback(() => {
    setOpenConfirmModal(false)
    setItemSelecionado(null)
  }, [])

  const handleConfirmExcluir = useCallback(async () => {
    if (!itemSelecionado) return

    try {
      await deleteAnaliseAmostraTerceira(itemSelecionado.id)
      setOpenConfirmModal(false)
      setItemSelecionado(null)
      await reloadAnalise()
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Erro ao excluir análise de amostra terceira:', error)
    }
  }, [itemSelecionado, reloadAnalise])

  const grids = '1fr 180px 120px'

  return (
    <>
      <Section name="ProgramacaoSelecaoEnsTerceiros">
        <SectionBox
          title="Programação: Seleção Ens. Terceiros"
          padding={false}
          right={
            <>
              <SectionOption
                icon={mdiPlusCircle}
                tooltip="Selecionar clientes"
                onClick={() => setOpenModal(true)}
              />
            </>
          }
        >
          <div style={{ padding: 16 }}>
            <List name="programacaoSelecaoEnsTerceiros">
              <ListSection type="header">
                <ListRow grid={grids}>
                  {['Titulo', 'Data de cadastro', 'Opções'].map((column, index) => (
                    <ListColumn key={index} text={column} />
                  ))}
                </ListRow>
              </ListSection>
              <ListSection type="main">
                {loadingAnalise && (
                  <ListRow grid="1fr">
                    <ListColumn center>
                      <CircleSpinner size={32} color="grey" />
                    </ListColumn>
                  </ListRow>
                )}

                {!loadingAnalise &&
                  listaAnalise.map((item, index) => (
                    <ListRow
                      key={item.id ?? index}
                      zebra={index % 2 === 0}
                      grid={grids}
                    >
                      <ListColumn text={item.nomesClientes} />
                      <ListColumn
                        text={
                          item.dtCadastro
                            ? new Date(item.dtCadastro).toLocaleDateString()
                            : '-'
                        }
                      />
                      <ListColumn center>
                        <div style={{ display: 'flex', justifyContent: 'center', gap: 12 }}>
                          <ListOption
                            icon={mdiMicrosoftExcel}
                            tooltip="Exportar Excel"
                            onClick={e => {
                              e.preventDefault()
                              excelProgramacaoSelecaoEnsTerceiros(item)
                            }}
                          />
                          <ListOption
                            icon={mdiDelete}
                            status="error"
                            tooltip="Excluir"
                            onClick={e => {
                              e.preventDefault()
                              handleOpenConfirmExcluir(item)
                            }}
                          />
                        </div>
                      </ListColumn>
                    </ListRow>
                  ))}

                {!loadingAnalise && listaAnalise.length === 0 && (
                  <ListRow grid="1fr">
                    <ListColumn text="Nenhum registro encontrado." />
                  </ListRow>
                )}
              </ListSection>
            </List>
          </div>
        </SectionBox>
      </Section>

      <Modal
        open={openModal}
        setOpen={setOpenModal}
        width="900px"
        title="Selecionar clientes"
        actions={[]}
      >
        {requestGet.loading && (
          <div className="center" style={{ padding: '16px 0' }}>
            <CircleSpinner size={32} color="grey" />
          </div>
        )}
        {!requestGet.loading && (
          <div
            style={{
              paddingTop: '4px',
              minHeight: 260,
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'flex-start'
            }}
          >

            <TextField 
            variant="standard" 
            autoComplete='false'
            label="Titulo para o documento"
              fullWidth   placeholder="Descrição" value={titulo} onChange={e => {setTitulo(e.target.value as string)}} 
              />
                                     
            <MagicSelectForm
              options={optionsPessoas}
              selected={selectedPessoas}
              setSelected={setSelectedPessoas}
              placeholder="Selecione os clientes para programação de ensaios terceiros..."
              onAdd={handleAddSelecionados}
              addTooltip="Adicionar clientes selecionados"
            />
          </div>
        )}
      </Modal>

      <Modal
        open={openConfirmModal}
        setOpen={setOpenConfirmModal}
        width="480px"
        title="Excluir programação"
        actions={[
          {
            label: 'Cancelar',
            theme: 'outline',
            onClick: handleCancelExcluir
          },
          {
            label: 'Excluir',
            theme: 'default',
            onClick: handleConfirmExcluir
          }
        ]}
      >
        <p style={{ fontSize: '0.9rem' }}>
          Tem certeza que deseja excluir a programação para{' '}
          <strong>{itemSelecionado?.nomesClientes}</strong>?
        </p>
      </Modal>
    </>
  )
}

export default ProgramacaoSelecaoEnsTerceiros

